export default "__VITE_ASSET__2f712e66__"